import { defineMessages } from 'react-intl';

const _default_1: {
	searchApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewWorkItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchApps: {
		id: 'rovo.search.navigation.buttons.searchApps',
		defaultMessage: 'Search all apps',
		description: 'Button label for search all the apps displayed in issue navigator',
	},
	viewWorkItems: {
		id: 'rovo.search.navigation.buttons.viewWorkItems',
		defaultMessage: 'View all work items',
		description: 'Button label for search all work items displayed in full page search',
	},
});
export default _default_1;
